export default "__VITE_ASSET__fd802764__"